import styled from '@mint-lib/styled';
import InputBase from '@mui/material/InputBase';

export const StyledInputBase = styled(InputBase)(({ theme, disabled }) => ({
  '&.MuiInputBase-root': {
    height: '1.5rem',
    minHeight: '1.5rem',
    width: '16.5rem',
    borderRadius: '6px !important',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: `inset 0 0 0 1px ${theme.palette.action.focusBorder}`,
    },
    '&:focus': {
      boxShadow: `inset 0 0 0 2px ${theme.palette.action.focusBorder}`,
    },
    '&:focus-within': {
      boxShadow: `inset 0 0 0 2px ${theme.palette.action.focusBorder}`,
    },
    backgroundColor: theme.palette.ui.field02,
    input: {
      padding: '0.25rem 0.5rem',
    },
    color: disabled && theme.palette.text.disabled,
    pointerEvents: disabled ? 'none' : 'auto',
  },
}));
